import React, { useCallback } from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';

import { Breadcrumbs } from '../../common/components/navigation';
import PatrolSummary from './details/PatrolSummary';
import { useFindingContext } from '../../finding/contexts/findingContext';
import PatrolListIframe from './list/PatrolListIframe';

const PatrolPageIframe = () => {
  const { setClickedFinding } = useFindingContext();

  const history = useHistory();
  const { path, url } = useRouteMatch();

  const returnToList = useCallback(() => {
    history.push(url);
  }, [history, url]);

  const handleBackClick = useCallback(() => {
    setClickedFinding(undefined);
    returnToList();
  }, [returnToList, setClickedFinding]);

  return (
    <>
      <Breadcrumbs entityType="patrol" />

      <Switch>
        <Route strict path={`${path}/:id`}>
          <PatrolSummary onBackClick={handleBackClick} />
        </Route>

        <Route strict path={`${path}`}>
          <PatrolListIframe />
        </Route>
      </Switch>
    </>
  );
};

export default React.memo(PatrolPageIframe);
